import { createSlice } from '@reduxjs/toolkit';
import { ANNOTATORS_INITIAL_STATE } from './annotators.constants';
import {
  getAnnotatorsReducer,
  getAnnotatorTargetsReducer,
  getAnnotatorPresetsReducer,
  createAnnotatorPresetReducer,
  updateAnnotatorPresetReducer,
  deleteAnnotatorPresetReducer,
  getAllAnnotationJobsReducer,
  cancelAnnotationJobReducer,
} from './annotators.reducers';

const annotatorsSlice = createSlice({
  name: 'annotators',
  initialState: ANNOTATORS_INITIAL_STATE,
  reducers: {},
  extraReducers: builder => {
    getAnnotatorsReducer(builder);
    getAnnotatorTargetsReducer(builder);
    getAnnotatorPresetsReducer(builder);
    createAnnotatorPresetReducer(builder);
    updateAnnotatorPresetReducer(builder);
    deleteAnnotatorPresetReducer(builder);
    getAllAnnotationJobsReducer(builder);
    cancelAnnotationJobReducer(builder);
  },
});

export default annotatorsSlice.reducer;
